import { render, staticRenderFns } from "./ApprovalDocument2.vue?vue&type=template&id=9c244fc4&scoped=true"
import script from "./ApprovalDocument2.vue?vue&type=script&lang=js"
export * from "./ApprovalDocument2.vue?vue&type=script&lang=js"
import style0 from "./ApprovalDocument2.vue?vue&type=style&index=0&id=9c244fc4&prod&lang=scss&scoped=true"
import style1 from "./ApprovalDocument2.vue?vue&type=style&index=1&id=9c244fc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c244fc4",
  null
  
)

export default component.exports